import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ManagementCalculator from './Calculator/ManagementCalculator';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
   <Route path='/' element={<ManagementCalculator/>}/>
   </Routes>
   </BrowserRouter>
    </div>
  );
}

export default App;
